import all from "../markers/all.png";
import automate from "../markers/automate.png";
import online from "../markers/online.png";

/**
 * wrapper for marker icon gmap
 */
export class Marker {
  name = "";

  /** instance of marker */
  _marker = null;

  /** instance of map */
  _map = null;

  /** instance of info window */
  _infowindow = null;

  _position = {};

  _eventListener = [];

  constructor(map, position, type) {
    this._map = map;
    this._position = position;
    this._marker = new window.google.maps.Marker({
      position: position,
      map: map,
      // animation: window.google.maps.Animation.DROP,
      icon: {
        url: type === "all" ? all : type === "online" ? online : automate
      }
    });
  }

  get position() {
    return this._position;
  }

  get marker() {
    return this._marker;
  }

  get eventListener() {
    return this._eventListener;
  }

  addListener = e => {
    this._eventListener.push(e);
  };

  /**
   * Link info window with marker
   * @param {*} infowindow
   * @param {*} cb
   */
  linkInfoWindow(infowindow, cb = () => {}) {
    this._infowindow = infowindow;
    this._marker.addListener("click", () => {
      this._infowindow.open(this._map, this._marker);
      this._marker.setVisible(false);
      cb(this._infowindow, this._marker);
    });
  }
}

export default Marker;
